import React, { Component } from 'react';
import Datas from '../data/about-us/about-us2.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/enrollStepsText.js";

class EnrollStepsText extends Component {
    render() {
        return (
            <Styles>
                {/* About Us 2 */}
                <section className="enroll-steps">
                        <Row>
                            <Col md="8">
                                <div className="about-content">
                                    <h4 className="about-title">{Datas.secTitle}</h4>
                                    {/* <p className="about-para">{Datas.secDesc}</p> */}

                                    {
                                        Datas.dataList.map((data, i) => (
                                            <div className="cta-box d-flex" key={i}>
                                                <div className="cta-number text-center">
                                                    <label>{i + 1}</label>
                                                </div>
                                                <div className="cta-content">
                                                    <h6>{data.iconTitle}</h6>
                                                    <p>{data.iconSubtitle}</p>
                                                </div>
                                            </div>
                                        ))
                                    }

                                </div>
                            </Col>
                            <Col md="4">
                                <div className="about-image">
                                    <img src={process.env.PUBLIC_URL + `/assets/images/LM/${Datas.aboutImageOne}`} className="main-img1" alt="" />
                                    <img src={process.env.PUBLIC_URL + `/assets/images/LM/${Datas.aboutImageTwo}`} className="main-img2" alt="" />
                                    <p className="exp-box"><span>{Datas.experianceYear}</span> Easy Steps</p>
                                </div>
                            </Col>
                        </Row>

                    

                   

                </section>
            </Styles>
        )
    }
}

export default EnrollStepsText